'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@tallinn-arvudes/ui/tallinn-design/Button';
import { Dialog } from '@tallinn-arvudes/ui/tallinn-design/Dialog';
import { type CookieValueTypes, getCookie, setCookie } from 'cookies-next/client';
import { type ReactNode, useEffect, useState } from 'react';
import { useIsClient } from 'usehooks-ts';
import { COOKIE_CONSENT_EXPIRATION_MS, COOKIE_CONSENT_NAME, CookieConsentValues, cookieOptions } from './constants';
export const CookieConsent = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const isClient = useIsClient();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getCookie(COOKIE_CONSENT_NAME);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const cookieConsent = t1;
  const [consent, setConsent] = useState(cookieConsent);
  let t2;
  let t3;
  if ($[1] !== consent) {
    t2 = () => {
      if (!consent) {
        return;
      }
      if (consent === CookieConsentValues.granted) {
        window.gtag("consent", "update", {
          functionality_storage: "granted",
          analytics_storage: "granted"
        });
      } else {
        window.gtag("consent", "update", {
          functionality_storage: "denied",
          analytics_storage: "denied"
        });
      }
    };
    t3 = [consent];
    $[1] = consent;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (!isClient) {
    return;
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setCookie(COOKIE_CONSENT_NAME, CookieConsentValues.granted, {
        ...cookieOptions,
        expires: new Date(Date.now() + COOKIE_CONSENT_EXPIRATION_MS)
      });
      setConsent(CookieConsentValues.granted);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleAcceptCookies = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setCookie(COOKIE_CONSENT_NAME, CookieConsentValues.denied, {
        ...cookieOptions,
        expires: new Date(Date.now() + COOKIE_CONSENT_EXPIRATION_MS)
      });
      setConsent(CookieConsentValues.denied);
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleRejectCookies = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button variant="tertiary-neutral" className="!text-white hover:!text-white focus-within:!text-black font-normal" onClick={() => {
      setConsent(undefined);
    }}>Küpsiste sätted</Button>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = consent === undefined;
  let t8;
  if ($[7] !== children || $[8] !== t7) {
    t8 = <>{t6}<Dialog isOpen={t7} onClose={handleRejectCookies} onAccept={handleAcceptCookies} title={"K\xFCpsiste kasutamine"} closeLabel={"Ei, ait\xE4h"} acceptLabel={"Luba k\xFCpsised"} size="medium" anchor="bottom">{children}</Dialog></>;
    $[7] = children;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};